import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const Spinner = ({ width, height }) => (
  <span
    className="Spinner"
    style={{ width, height }}
  >
    <style jsx>{styles}</style>
  </span>
)

Spinner.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

Spinner.defaultProps = {
  width: '48px',
  height: '48px',
}

export default Spinner
